<template>
  <div class="row">
    <div class="col-lg-8">
      <h2 class="inline">Pickup Point Update</h2>
    </div>

    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-8">
              <h4 class="card-title">List of Pickup Point</h4>
            </div>
            <div class="col-lg-4 text-right" style="margin-bottom: 1%">
              <base-button @click="addPickup" round type="green">
                <i class="tim-icons icon-simple-add"></i>&nbsp;Add Pickup Point
              </base-button>
            </div>
          </div>
        </div>

        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <base-input label="rows visible">
              <el-select
                class="select-info mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </base-input>
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
              ></el-input>
            </base-input>
          </div>

          <el-table
            :data="queriedPickupPoint"
            @row-dblclick="getPickup"
            :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            <el-table-column
              label="Pickup Point Name"
              prop="PickupName"
              :min-width="150"
            ></el-table-column>
            <el-table-column
              v-if="false"
              prop="PickupID"
              :min-width="150"
            ></el-table-column>
            <el-table-column
              label="MON"
              prop="Monday"
              :min-width="50"
            ></el-table-column>
            <el-table-column
              label="TUE"
              prop="Tuesday"
              :min-width="50"
            ></el-table-column>
            <el-table-column
              label="WED"
              prop="Wednesday"
              :min-width="50"
            ></el-table-column>
            <el-table-column
              label="THU"
              prop="Thursday"
              :min-width="50"
            ></el-table-column>
            <el-table-column
              label="FRI"
              prop="Friday"
              :min-width="50"
            ></el-table-column>
            <el-table-column
              label="SAT"
              prop="Saturday"
              :min-width="50"
            ></el-table-column>
            <el-table-column
              label="SUN"
              prop="Sunday"
              :min-width="50"
            ></el-table-column>
            <el-table-column :min-width="135" align="right" label="Actions">
              <div slot-scope="props">
                <el-tooltip content="Delete" placement="bottom" effect="light">
                  <base-button
                    @click.native="handleDelete(props.$index, props.row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-simple-remove"></i>
                  </base-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { BasePagination, Modal, WizardTab, SimpleWizard } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import Axios from "axios";

export default {
  components: {
    BasePagination,
    WizardTab,
    SimpleWizard,
    Modal,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedPickupPoint() {
      let result = this.tablePickupPoint;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tablePickupPoint.length;
    },
  },

  data() {
    return {
      modals: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["PickupName"],
      tablePickupPoint: [],
      searchedData: [],
      fuseSearch: null,
    };
  },

  methods: {
    getPickup(row, column, event) {
      const pickupID = row.PickupID;
      this.$router.push({ path: `/Greencard/PickupPointForm/${pickupID}` });
    },
    addPickup() {
      const custID = this.$route.params.custid;
      this.$router.push({ path: `/Greencard/PickupPointAdd/${custID}` });
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          this.$http
            .delete(`:9991/api/v1/customers/pickup/${row.PickupID}`)
            .then((res) => {
              if (!res.error) {
                swal({
                  title: res.message,
                  text: `You deleted ${row.PickupName}`,
                  type: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              }
            });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tablePickupPoint.findIndex(
        (tableRow) => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tablePickupPoint.splice(indexToDelete, 1);
      }
    },
    listPickup() {
      const custID = this.$route.params.custid;
      this.$http
        .post(`:9991/api/v1/customers/pickupList/${custID}`)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let data = {
                id: i,
                PickupName: response[i].PickupName,
                PickupID: response[i].PickupID,
                Monday: response[i].PickupFreq[0],
                Tuesday: response[i].PickupFreq[1],
                Wednesday: response[i].PickupFreq[2],
                Thursday: response[i].PickupFreq[3],
                Friday: response[i].PickupFreq[4],
                Saturday: response[i].PickupFreq[5],
                Sunday: response[i].PickupFreq[6],
              };
              this.tablePickupPoint.push(data);
            }
          }
        });
    },
  },
  created() {
    this.listPickup();
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tablePickupPoint, {
      keys: ["PickupName"],
      threshold: 0.3,
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tablePickupPoint;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style lang="scss">
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
.group-form {
  border: solid red;
  border-radius: 20px;
  padding: 2%;
  margin-bottom: 2%;
  margin-right: 2%;
}
</style>
